<template>
<!-- Footer -->
    <footer>
    <p>Copyright © 2020 Dreamguys.</p>                  
    </footer>
<!-- /Footer -->	
</template>